import * as Models from "../../ts/rlAdmin.models";
import { AdminConfigService } from "../../services/admin-config-service";
import { NotifyService } from "../../services/notify-service";
import { DateLocaleService } from "../../services/date-locale-service";

export class CurrencyConversionConfigController {
    static $inject = ["$scope", "$window", "$location", "$filter", "$q", "adminConfigService", "notifyService", "dateLocaleService"];
    createCurrencyConversion: boolean;
    setCompanyCurrency: boolean;
    editCurrencyConversion: boolean;
    companyCurrency: string;
    newCompanyCurrency: string;
    newTransactionCurrency: string;
    newRate: number;
    newEffectiveDate: string;
    filterCurrent: boolean;
    filterMonth: string;
    result: string;
    pickedFile: Models.IFilestackPickFile;
    selectedFileName: string;
    divCurrencyConversionList: Models.ICurrencyConversionInfo[];
    filteredDivCurrencyConversionList: Models.ICurrencyConversionInfo[];
    editCurrencyConversionInfo: Models.ICurrencyConversionInfo;
    getHistoricData: boolean;
    companyCurrencySetting: Models.IDivSetting;
    hasFileValidationErrors: boolean;
    fileValidationErrors: { [key: number]: string };
    companyCurrencyValues: Models.ICharacteristicValue[];
    initialCompanyCurrencyValues: Models.ICharacteristicValue[];
    selectedTrxCurrencyID: number;

    constructor(private $scope: ng.IScope, private $window: ng.IWindowService, private $location: ng.ILocationService, private $filter: ng.IFilterService,
        private $q: ng.IQService, private adminConfigService: AdminConfigService, private notifyService: NotifyService,
        private dateLocaleService: DateLocaleService) {

        this.companyCurrency = "";
        this.newCompanyCurrency = "";
        this.newTransactionCurrency = "";
        this.newRate = 0;
        this.newEffectiveDate = "";
        this.createCurrencyConversion = false;
        this.setCompanyCurrency = false;
        this.filterCurrent = false;
        this.filterMonth = "";
        this.pickedFile = null;
        this.selectedFileName = "";
        this.divCurrencyConversionList = [];
        this.filteredDivCurrencyConversionList = [];
        this.editCurrencyConversion = false;
        this.getHistoricData = false;
        this.hasFileValidationErrors = false;


        this.$scope.$watch(() => this.pickedFile,
            (newValue, oldValue) => {
                if (newValue != oldValue && newValue != null) {
                    this.selectedFileName = newValue[0].key;
                    this.ImportBulkCurrencyConversionFile();
                }
            }, true);

        this.$scope.$watch(() => this.getHistoricData,
            (newValue: boolean, oldValue: boolean) => {
                if (newValue != oldValue) {
                    this.notifyService.startProgress();
                    return this.adminConfigService.getCurrencyConversionList(newValue)
                        .then((results) => {
                            this.divCurrencyConversionList = results;
                            this.getCurrencyConversionListForTRXCurrency();
                        })
                        .finally(() => {
                            this.notifyService.endProgress();
                        });
                }
            }, true);

        this.$scope.$watch(() => this.selectedTrxCurrencyID,
            (newValue: number, oldValue: number) => {
                if (newValue != oldValue) {
                    this.getCurrencyConversionListForTRXCurrency();
                }
            }, true);
    }

    Init() {
        var promise4 = this.adminConfigService.getGetStandardCurrencyList()
            .then((result) => {
                this.initialCompanyCurrencyValues = result;
            });

        var promise1 = this.adminConfigService.getCompanyCurrency()
            .then((result) => {
                this.companyCurrency = result.data;
            });

        var promise2 = this.adminConfigService.getCompanyCurrencyValueList()
            .then((result) => {
                this.companyCurrencyValues = result;
            });

        var promise3 = this.adminConfigService.getCurrencyConversionList(this.getHistoricData)
            .then((results) => {
                this.divCurrencyConversionList = results;
                this.getCurrencyConversionListForTRXCurrency();
            });

        this.$q.all([promise1, promise2, promise3, promise4])
            .then(() => {
                if (_.isEmpty(this.companyCurrency)) {
                    this.setCompanyCurrency = true;
                    alert("There is no company currency set up. Please select a company currency now.");

                }
            });;


    }

    Create() {
        if (_.isEmpty(this.companyCurrency)) {
            alert("There is no company currency set up. Please contact Rightsline Administrator.");
        }
        else {
            this.createCurrencyConversion = true;
            this.editCurrencyConversion = false;
        }
    }

    Set() {
        this.setCompanyCurrency = true;
    }

    Edit(editCCInfo: Models.ICurrencyConversionInfo) {
        this.createCurrencyConversion = false;
        this.editCurrencyConversion = true;
        this.editCurrencyConversionInfo = _.cloneDeep(editCCInfo);
        var effectiveDateUTC = this.editCurrencyConversionInfo.effectiveDate;
        var editEffectiveDateLocalizeMoment = effectiveDateUTC;
        this.editCurrencyConversionInfo.effectiveDate = editEffectiveDateLocalizeMoment;
    }

    CreateCurConversionRecord(form: ng.IFormController) {
        if (form.$valid) {
            if (this.createCurrencyConversion) {
                this.notifyService.startProgress();

                var createCurrencyConversionInfo: Models.ICurrencyConversionInfo = {
                    currencyConversionID: "",
                    companyCurrency: this.companyCurrency,
                    transactionCurrency: this.newTransactionCurrency,
                    rate: this.newRate,
                    effectiveDate: this.dateLocaleService.parseMoment(this.newEffectiveDate).format("MM-DD-YYYY")
                }

                this.adminConfigService.createCurrencyConversionInfo(createCurrencyConversionInfo)
                    .then(result => {
                        if (result) {
                            this.notifyService.notifySuccess("Successfully created a Currency Conversion Record");
                        }
                        else {
                            this.notifyService.notifyError("Error creating a Currency Conversion Record");
                        }
                    })
                    .finally(() => {
                        this.createCurrencyConversion = false;
                        this.editCurrencyConversion = false;
                        this.newTransactionCurrency = "";
                        this.newRate = null;
                        this.newEffectiveDate = "";
                        this.Init();
                        this.notifyService.endProgress();
                    });
            }
        };
    }

    Save(editCCInfo: Models.ICurrencyConversionInfo) {
        if (this.editCurrencyConversion) {
            this.notifyService.startProgress();
            editCCInfo.effectiveDate = this.dateLocaleService.parseMoment(editCCInfo.effectiveDate).format("MM-DD-YYYY");
            this.adminConfigService.updateCurrencyConversionInfo(editCCInfo)
                .then(result => {
                    if (result) {
                        this.notifyService.notifySuccess("Successfully updated a Currency Conversion Record");
                    }
                    else {
                        this.notifyService.notifyError("Error updating a Currency Conversion Record");
                    }
                })
                .finally(() => {
                    this.createCurrencyConversion = false;
                    this.editCurrencyConversion = false;
                    this.Init();
                    this.notifyService.endProgress();
                });
        }
    }

    CreateCompanyCurrency(form: ng.IFormController) {
        if (form.$valid) {
            if (this.setCompanyCurrency) {
                this.notifyService.startProgress();

                var createDivSettingValSet: Models.IDivSetting = {
                    divSettingID: "",
                    key: 'division_currency_value_id',
                    value: this.initialCompanyCurrencyValues.filter(x => x.charValueLabel == this.newCompanyCurrency)[0].charValueID.toString()
                };

                var createDivSettingSet: Models.IDivSetting = {
                    divSettingID: "",
                    key: 'currency_value_set_id',
                    value: this.initialCompanyCurrencyValues.filter(x => x.charValueLabel == this.newCompanyCurrency)[0].charValueSetID.toString()
                };

                this.adminConfigService.createDivSetting(createDivSettingValSet)
                    .then(result => {
                        if (!result) {
                            this.notifyService.notifyError("Error creating a Base Currency");
                        }
                    });

                this.adminConfigService.createDivSetting(createDivSettingSet)
                    .then(result => {
                        if (result) {
                            this.notifyService.notifySuccess("Successfully Set the Base Currency");
                        }
                        else {
                            this.notifyService.notifyError("Error creating a Base Currency");
                        }
                    })
                    .finally(() => {
                        this.setCompanyCurrency = false;
                        this.Init();
                        this.notifyService.endProgress();
                    });
            }
        };
    }

    Delete(currencyConversionInfoID: string) {
        this.notifyService.startProgress();
        if (this.$window.confirm("Are you sure you want to Delete this Currency Conversion?")) {
            return this.adminConfigService.deleteCurrencyConversionInfo(currencyConversionInfoID)
                .then((result) => {
                    this.notifyService.notifySuccess("Currency Conversion Info deleted successfully");
                }).finally(() => {
                    this.Init();
                    this.notifyService.endProgress();
                });
        }
        else {
            this.notifyService.broadcastDone();
        }
    }

    ImportBulkCurrencyConversionFile() {
        this.notifyService.startProgress();

        return this.adminConfigService.uploadCurrencyConversionInfo(this.selectedFileName)
            .then((results) => {
                this.fileValidationErrors = results["data"];
                var validationResultKeys = _.keys(this.fileValidationErrors).map((key) => _.parseInt(key));
                if (validationResultKeys.length > 0) {
                    this.hasFileValidationErrors = true;
                }
                else {
                    this.hasFileValidationErrors = false;
                }
            })
            .finally(() => {
                this.Init();
                this.notifyService.endProgress();
            });
    }

    getCurrencyConversionListForTRXCurrency() {
        if (this.selectedTrxCurrencyID > 0) {
            var trxCurrency = _.find(this.companyCurrencyValues, (x) => x.charValueID == this.selectedTrxCurrencyID);
            this.filteredDivCurrencyConversionList = this.divCurrencyConversionList.filter(x => x.transactionCurrency == trxCurrency.charValueLabel);
        }
        else {
            this.filteredDivCurrencyConversionList = this.divCurrencyConversionList;
        }

    }
}
